import { PeriscopeBaseRecord } from '@sonar-software/sonar-ts-types';

export const getRowKey = (record: PeriscopeBaseRecord) => record.sonarObjectId;
